import { render, staticRenderFns } from "./UserLikes.vue?vue&type=template&id=1c9ba853&"
import script from "./UserLikes.vue?vue&type=script&lang=js&"
export * from "./UserLikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports